const getPathToTableRow = (row, { subRowKey = "children" } = {}) => {
  if (row?.index === undefined) {
    return [];
  }

  if (typeof row?.getParentRow !== "function") {
    return [row.index];
  }

  const path = [row.index];
  const visited = new Set(); // Prevent circular references

  const parseCurrentRow = (rootRow) => {
    // Circular reference check
    if (visited.has(rootRow)) {
      console.warn("Circular reference detected in table row hierarchy");
      return; // Circulate reference deteched; bomb out.
    }

    visited.add(rootRow);
    const parentRow = rootRow.getParentRow?.();
    if (!parentRow) {
      return;
    }

    // We add `subRowKey` because if we're getting nested
    // info, we first want the key of the child Array, _then_
    // its associated index ...
    path.unshift(parentRow.index, subRowKey);
    parseCurrentRow(parentRow);
  };

  parseCurrentRow(row);

  return path;
};

export default getPathToTableRow;
